import PageHeader from 'ui/pageHeader/PageHeader';
import { Skeleton } from 'ui/skeleton/Skeleton';
import { TemplateDiffModals } from './modals/TemplateDiffModals';
import { ContentPreview } from './ContentPreview/ContentPreview';
import { useTemplateDiffContext } from '../context/TemplateDiffContext';

export const TemplateDiff = () => {
  const { template, contentLeft, contentRight, isLoading } = useTemplateDiffContext();
  const dataFetched = !!template && !!contentLeft && !!contentRight;

  return (
    <>
      <PageHeader
        documentTitle={`Comparing revisions`}
        breadcrumb={{
          content: 'Back to template history',
          href: `/templates/history?templateId=${template?.id}`,
        }}
      >
        Comparing revisions for {template?.name}
      </PageHeader>
      {isLoading && <Skeleton data-test="template-diff-skeleton" height={400} />}
      {dataFetched && (
        <div data-test="template-diff-content">
          <ContentPreview
            template={template}
            contentLeft={contentLeft}
            contentRight={contentRight}
          />
        </div>
      )}
      <TemplateDiffModals />
    </>
  );
};
